module.exports = __webpack_public_path__ + "static/NotoSerifSC-Medium-d5c99fd92a1984a41aeb1d8e6d8d84f1.otf";